import { useEffect, useRef } from 'react';
import SecurityOrderSseService from '../../../services/securityOrderSseService';

/**
 * 订单列表 SSE Hook。
 *
 * 组件挂载时建立连接，卸载时主动断开；onRefresh 使用 ref 保存，
 * 避免筛选条件变化后重新创建 SSE 连接，同时保证刷新时使用最新函数。
 */
const useSecurityOrderSse = (onRefresh: () => void | Promise<void>) => {
    const refreshRef = useRef(onRefresh);
    refreshRef.current = onRefresh;

    useEffect(() => {
        // 一个 Dashboard 实例只创建一个 SSE 连接。
        const sseService = new SecurityOrderSseService({
            onRefresh: () => refreshRef.current(),
            // 服务内部会自动重连，这里只记录连接异常。
            onError: (error) => console.warn('Security order SSE disconnected. Retrying...', error),
        });

        sseService.start();
        // 页面离开或组件销毁时释放连接，避免后台继续刷新。
        return () => sseService.stop();
    }, []);
};

export default useSecurityOrderSse;
